import React from 'react';
import { Card } from '@/components/ui/card';
import { useAuth } from '@/context/auth';
import { Badge } from '@/components/ui/badge';
import { Clock, BookOpen } from 'lucide-react';

interface Assessment {
  id: string;
  title: string;
  description: string;
  duration: string;
  type: 'skills' | 'personality' | 'interests';
  status: 'pending' | 'in_progress' | 'completed';
}

export function AssessmentList() {
  const { user } = useAuth();
  
  const assessments: Assessment[] = [
    {
      id: '1',
      title: 'Skills Assessment',
      description: 'Evaluate your technical and soft skills',
      duration: '15 mins',
      type: 'skills',
      status: 'pending'
    },
    {
      id: '2',
      title: 'Career Interests',
      description: 'Discover your professional interests',
      duration: '10 mins',
      type: 'interests',
      status: 'pending'
    }
  ];

  return (
    <Card className="p-6">
      <h2 className="text-xl font-semibold mb-4">Assessments</h2>
      <div className="space-y-4">
        {assessments.map((assessment) => (
          <div 
            key={assessment.id}
            className="flex items-center justify-between p-4 rounded-lg bg-slate-800/50"
          >
            <div className="space-y-1">
              <h3 className="font-medium">{assessment.title}</h3>
              <p className="text-sm text-slate-400">{assessment.description}</p>
              <div className="flex items-center gap-4 mt-2">
                <span className="flex items-center text-sm text-slate-400">
                  <Clock className="w-4 h-4 mr-1" />
                  {assessment.duration}
                </span>
                <Badge variant={assessment.status === 'completed' ? 'success' : 'secondary'}>
                  {assessment.status}
                </Badge>
              </div>
            </div>
            <BookOpen className="w-5 h-5 text-slate-400" />
          </div>
        ))}
      </div>
    </Card>
  );
}